import { SplatImage } from './splat-image.model';

export class SplatImageMap {

    images: Array<SplatImage> = [];
    protected loaded: boolean = false;

    add(name: string, url: string): void {
        if (this.images.filter(image => image.name === name).length > 0) {
            throw new Error(`cannot add SplatImage with name = "${name}". name is not unique`);
        }
        this.images.push(new SplatImage(name, url));
    }

    getImage(name: string): SplatImage {
        const items: Array<SplatImage> = this.images.filter(splatImage => splatImage.name === name);
        if (items.length) {
            return items[0];
        } else {
            return undefined;
        }
    }

    loadAll(): Promise<void> {
        if (this.loaded) {
            return Promise.resolve();
        }
        return Promise.all(this.images.map(splatImage => splatImage.load())).then(() => {
            this.loaded = true;
        });
    }
}



// WEBPACK FOOTER //
// ./src/vas/controls/splat/form/lib/splat-image-map.model.ts